import swiperUtil from '../utils/swiper-util';

let swiperCarousel = null;

export default (node) => {
  const mainSwiperNode = node.querySelector('[data-main-swiper]');
  const buttonNext = node.querySelector('[data-next]');
  const buttonPrev = node.querySelector('[data-prev]');
  const getSwiperThumbs = () => node.querySelectorAll('[data-swiper-thumb]');

  const handleThumbClick = (thumb) => {
    const { productCarouselIndex } = thumb.dataset;
    const slideIndex = node.querySelector(`[data-media-id-main="${productCarouselIndex}"]`).dataset.productCarouselIndex;
    swiperCarousel.slideTo(slideIndex);

    getSwiperThumbs().forEach((thumbEl) => {
      thumbEl.classList.remove('image-selected');
    });

    thumb.classList.add('image-selected');
  };

  const initSliders = () => {
    swiperCarousel = swiperUtil(mainSwiperNode, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '[data-slider-pagination]',
        clickable: true,
      },
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      preventClicks: true,
      preventClicksPropagation: false,
      threshold: 10, // small drag threshold
      preventInteractionOnTransition: true,
      breakpoints: {
        768: {
          allowTouchMove: false,
        },
      },
    });

    swiperCarousel.on('slideChange', () => {
      const slideActive = swiperCarousel.slides[swiperCarousel.realIndex];
      const slideIndex = slideActive.dataset.productCarouselIndex;
      getSwiperThumbs().forEach((thumb) => {
        thumb.classList.remove('image-selected');
        if (thumb.dataset.productCarouselIndex === slideIndex) {
          thumb.classList.add('image-selected');
        }
      });
    });

    setTimeout(() => {
      mainSwiperNode.classList.remove('opacity-0');
    }, 400);
  };


  const showVariantImages = (variantId) => {
    if (!variantId) return;

    const videoPosition = parseInt(node.dataset.videoPosition, 10) || 0;

    // The video slide/thumb only exist once in the DOM, embedded within whichever
    // variant's images were rendered first. Since they stay visible for every
    // variant, they must be physically relocated into the currently selected
    // variant's slide sequence — otherwise, once that variant's own slides are
    // hidden, the video becomes the first *visible* slide regardless of `video_position`.

    // --- Main slider ---
    const videoSlide = node.querySelector('[data-media-main-type="video"]');
    const videoSlideParent = videoSlide ? videoSlide.parentElement : null;
    const mainImageSlides = Array.from(node.querySelectorAll('[data-media-main-variant-id]')).filter(
      (slide) => slide !== videoSlide
    );

    if (videoSlide) videoSlide.remove();

    let mainIndex = 0;
    let videoSlideInserted = false;
    mainImageSlides.forEach((swiperSlide) => {
      if (swiperSlide.dataset.mediaMainVariantId !== variantId) {
        swiperSlide.classList.add('hidden');
        swiperSlide.dataset.productCarouselIndex = '';
        return;
      }

      swiperSlide.classList.remove('hidden');
      swiperSlide.dataset.productCarouselIndex = mainIndex;
      mainIndex++;

      if (videoSlide && !videoSlideInserted && videoPosition > 0 && mainIndex === videoPosition) {
        swiperSlide.insertAdjacentElement('afterend', videoSlide);
        videoSlide.dataset.productCarouselIndex = mainIndex;
        mainIndex++;
        videoSlideInserted = true;
      }
    });

    if (videoSlide && !videoSlideInserted) {
      videoSlideParent.appendChild(videoSlide);
      videoSlide.dataset.productCarouselIndex = mainIndex;
    }

    // --- Thumbnails ---
    const videoThumb = node.querySelector('[data-swiper-thumb][data-media-type="video"]');
    const videoThumbParent = videoThumb ? videoThumb.parentElement : null;
    const thumbSlides = Array.from(node.querySelectorAll('[data-media-color-thumbs]'));

    if (videoThumb) videoThumb.remove();

    let thumbIndex = 0;
    let videoThumbInserted = false;
    thumbSlides.forEach((swiperThumb) => {
      if (swiperThumb.dataset.mediaVariantId !== variantId) {
        swiperThumb.classList.add('hidden');
        return;
      }

      swiperThumb.classList.remove('hidden');
      thumbIndex++;

      if (videoThumb && !videoThumbInserted && videoPosition > 0 && thumbIndex === videoPosition) {
        swiperThumb.insertAdjacentElement('afterend', videoThumb);
        videoThumbInserted = true;
      }
    });

    if (videoThumb && !videoThumbInserted) {
      videoThumbParent.appendChild(videoThumb);
    }
  };

  /**
   * INIT
   */
  initSliders();


  // Enable thumbnails click interaction
  getSwiperThumbs().forEach((thumb) => {
    thumb.addEventListener('click', () => handleThumbClick(thumb));
  });

  // Watch for external trigger to focus on a specific image
  document.addEventListener('product-image:scroll-to-image', (e) => {
    const { node } = e.detail;
    handleThumbClick(node);
  });

  // Update carousel when a variant is selected
  document.addEventListener('new-variant:change', (e) => {
    const variantId = e.detail.variant;

    showVariantImages(variantId);
  });
};
